<template>
  <div class="ChukuBill app-container">
    <!--标题-->
    <el-tabs v-model="activeName" @tab-click="handleClicktab">
      <el-tab-pane label="客户提单" name="first">
        <div ref="searchBox" class="formBox margbot">
            <el-form ref="searchForm" :inline="true" size="mini" class="demo-form-inline" label-width="80px">
              <div class="formItemBox">
              <el-form-item label="提货单号:">
                <el-input v-model="searchForm.billNo" maxlength="50" placeholder="请输入提货单号"  size="mini"></el-input>
              </el-form-item>
              <el-form-item label="提货日期:">
                <el-date-picker size="mini" v-model="dateList" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="一级货主:" >
                <el-select v-model="searchForm.primaryCustomerTaxId" clearable filterable placeholder="请选择"  size="mini">
                  <el-option v-for="(item, index) in customerData" :key="index" :label="item.custerName" :value="item.taxpayerNumber">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="二级货主:" >
                <el-select v-model="searchForm.secondaryCustomerTaxId" clearable filterable placeholder="请选择"  size="mini">
                  <el-option v-for="(item, index) in customerData" :key="index" :label="item.custerName" :value="item.taxpayerNumber">
                  </el-option>
                </el-select>
              </el-form-item>
              <!-- <el-form-item label="货权方:" style="margin-top:5px;">
                <el-select v-model="searchForm.ownerCustomerTaxId" clearable filterable placeholder="请选择" style="width:170px" size="mini">
                    <el-option
                      v-for="(item, index) in HQData"
                      :key="index"
                      :label="item.custerName"
                      :value="item.taxpayerNumber"
                    >
                    </el-option>
                  </el-select>
              </el-form-item> -->
              <el-form-item label="车辆号牌:" >
                <el-input v-model="searchForm.plateNumber" maxlength="10" placeholder="请输入车牌号"  size="mini"></el-input>
              </el-form-item>

              <el-form-item label="单据状态:" >
                <el-select v-model="searchForm.emptyBillType" clearable placeholder="请选择单据状态" size="mini">
                  <el-option v-for="(item,index) in statusData" :key="index" :label="item.show_name" :value="item.item_no"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="客户单号:" >
                <el-input v-model="searchForm.outBillNo" maxlength="50" placeholder="请输入客户单号" size="mini"></el-input>
              </el-form-item>
              <el-form-item label="产地:" >
                <el-input v-model="searchForm.steelMillName" maxlength="10" placeholder="请输入产地"  size="mini"></el-input>
              </el-form-item>
              <el-form-item label="材质:" >
                <el-input v-model="searchForm.model" maxlength="10" placeholder="请输入材质" size="mini"></el-input>
              </el-form-item>
              <el-form-item label="规格:" >
                <el-input v-model="searchForm.specification" maxlength="10" placeholder="请输入规格" size="mini"></el-input>
              </el-form-item>
               </div>
              <el-form-item>
                <el-button type="primary" size="mini" @click="searchClick" btnCode="00cP005B001" v-if="btnFlg[0]">查询</el-button>
                <el-button type="primary" size="mini" @click="chongzhi" btnCode="00cP005B002" v-if="btnFlg[1]">重置</el-button>
                <el-button type="primary" size="mini" @click="xinzeng" btnCode="00cP005B003" v-if="btnFlg[2]">新增</el-button>
                <el-button type="primary" size="mini" @click="xiugai" btnCode="00cP005B004" v-if="btnFlg[3]">修改</el-button>
                <el-button type="primary" size="mini" @click="addPlan" btnCode="00cP005B005" v-if="btnFlg[4]">添加出库计划</el-button>
                <el-button type="primary" size="mini" @click="finished" btnCode="00cP005B006" v-if="btnFlg[5]">完成</el-button>
                <el-button type="primary" size="mini" @click="cancellation" btnCode="00cP005B007" v-if="btnFlg[6]">作废</el-button>
                <el-button type="primary" size="mini" @click="daochu" btnCode="00cP005B008" v-if="btnFlg[7]">导出</el-button>
              </el-form-item>
              <el-form-item>
                <span>
                未提吨数:
                <span style="color: red">{{ allstockWeightBill }}</span> &nbsp;吨
              </span>
              <span style="margin-left: 15px">
                未提件数:
                <span style="color: red">{{ allstockNumberBill }}</span> &nbsp;件
              </span>
              </el-form-item>
            </el-form>
        </div>
        <div :style="{height:h}" v-loading='tabLoadingA'>
          <el-table size="mini" border bordersize="mini"  height="100%" ref="tableList" :data="tableList" style="width:100%" :row-style="{height:'20px'}"
          :cell-style="{padding:'0px'}" class="tableComent" :header-cell-style="{background:'#F5F5F5',color:'black'}" highlight-current-row @row-click="dianjixuanzhong">
            <el-table-column type="index" prop="date" width="55" label="序号" align="center" ></el-table-column>
            <!-- <el-table-column label="操作">
                  <template v-slot="scope">
                    <el-button v-if="scope.row.source == '0'&&scope.row.emptyBillType=='0'" type="text" @click="tianjiahuowu(scope.row)">添加货物</el-button>
                  </template>
                </el-table-column> -->
            <el-table-column :show-overflow-tooltip="true" prop="billNo" label="提货单号" width="240px"></el-table-column>
            <el-table-column prop="createTime" label="提货时间" width="190px" :formatter="dateTimeFormat"></el-table-column>
            <el-table-column prop="" label="提单状态" width="110px">
              <template slot-scope="scope">
                <div>
                  <span v-if="scope.row.emptyBillType == '0'" style="color:orange;">{{scope.row.emptyBillTypeName}}</span>
                  <span v-if="scope.row.emptyBillType == '1'">{{scope.row.emptyBillTypeName}}</span>
                  <span v-if="scope.row.emptyBillType == '2'" style="color:#999;">{{scope.row.emptyBillTypeName}}</span>
                  <span v-if="scope.row.emptyBillType == '3'" style="color:green;">{{scope.row.emptyBillTypeName}}</span>
                </div>
              </template>
            </el-table-column>
            <!-- <el-table-column :show-overflow-tooltip="true" prop="invalidFlag" label="是否失效" width="100px" ></el-table-column> -->
            <el-table-column :show-overflow-tooltip="true" prop="outBillNo" label="客户单号" width="150px"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="primaryCustomerName" label="一级货主" width="230px"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="secondaryCustomerName" label="二级货主" width="230px"></el-table-column>
            <el-table-column prop="billTransferredGoods" label="提货总量（吨）" width="140px">
              <template v-slot="scope">
                <div>
                  <span v-if="scope.row.billTransferredGoods == undefined || scope.row.billTransferredGoods == ''">0</span>
                  <span v-else>{{Number(scope.row.billTransferredGoods).toFixed(4)}}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="actualBillTransferred" label="实际提货总量（吨）" width="150px">
              <template v-slot="scope">
                <div>
                  <span v-if="scope.row.actualBillTransferred == undefined || scope.row.actualBillTransferred == ''">0</span>
                  <span v-else>{{Number(scope.row.actualBillTransferred).toFixed(4)}}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="plateNumber" label="车牌号" width="200px"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="driverName" label="司机" width="200px"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="telephone" label="司机电话" width="200px"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="idNumber" label="身份证号" width="300px"></el-table-column>
            <!-- <el-table-column :show-overflow-tooltip="true" prop="carHoldFalg" label="是否扣车" width="100px" >
                  <template slot-scope="scope"><div>
                    <span v-if="scope.row.carHoldFalg == '0'">不扣</span>
                    <span v-else>扣车</span>
                  </div></template>
                </el-table-column> -->
            <el-table-column prop="" label="提单照片">
              <template slot-scope="scope">
                <div>
                  <el-button v-if="scope.row.source != 0" type="text" size="small" @click="handleClick(scope.row,'zp')">查看提单</el-button>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="sourceName" label="数据来源" width="120px"></el-table-column>
            <el-table-column prop="pickupCustomerName" label="提货客户" width="180px"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="remark" label="备注" width="180px">
              <!-- <template slot-scope="scope"><div>
                    <el-button type="text" size="small" @click="handleClick(scope.row,'bz')">查看</el-button>
                  </div></template> -->
            </el-table-column>
            <!-- <el-table-column :show-overflow-tooltip="true" prop="effectiveTime" label="有效开始时间" width="190px" >
                  <template slot-scope="scope"><div>
                    <span v-if="scope.row.effectiveTime!= '' || scope.row.effectiveTime != undefined || scope.row.effectiveTime != null">{{scope.row.effectiveTime | dateFormat}}</span>
                  </div></template>
                </el-table-column> -->
            <!-- <el-table-column :show-overflow-tooltip="true" prop="failureTime" label="有效结束时间" width="190px" >
                  <template slot-scope="scope"><div>
                    <span v-if="scope.row.failureTime!= '' || scope.row.failureTime != undefined || scope.row.failureTime != null">{{scope.row.failureTime | dateFormat}}</span>
                  </div></template>
                </el-table-column> -->
            <el-table-column prop="createUser" label="创建人" width="130px"></el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="190px" :formatter="dateTimeFormat"></el-table-column>
            <el-table-column prop="voidName" label="作废人" width="130px"></el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="voidReason" label="作废原因" width="200px"></el-table-column>
            <el-table-column prop="voidTime" label="作废时间" width="190px" :formatter="dateTimeFormat"></el-table-column>
          </el-table>
        </div>
        <!--分页-->
        <div class="pags" style="text-align: right">
          <el-pagination background @current-change="handleCurrentChange" :current-page="searchForm.pageNo" :page-size="searchForm.pageSize" :page-sizes="[10, 20, 30, 40, 50]" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" :total="totalA"></el-pagination>
        </div>
        <!--出库单详情-->
        <div class="market_out">
          <div class="detailsTitle">
            <h4>货物详情</h4>
          </div>
          <!--货物详情-->
          <div>
            <div ref="searchBox2" style="margin-top: 5px;margin-bottom:5px;margin-left:10px;">
              <span>
                总吨数:
                <span style="color: red">{{Number(allWeight)}}</span> &nbsp;吨
              </span>
              <span style="margin-left: 15px">
                总件数:
                <span style="color: red">{{allNumber}}</span> &nbsp;件
              </span>
            </div>
            <!--详情表格-->
            <div class="ruKuZuoyeWarp-body-detailsTab">
              <div class="ruKuZuoyeWarp-body-table" :style="{ height: detailsH }">
                <el-table height="100%" border bordersize="mini" size="mini" ref="tabref" :data="detailsData" style="width:100%" highlight-current-row :header-cell-style="{background:'#F5F5F5',color:'black'}" @row-click="dianjiXiangqingtable">
                  <el-table-column prop="productTypeName" label="货物类型"></el-table-column>
                  <el-table-column prop="steelMillName" label="产地" width="250px"></el-table-column>
                  <el-table-column prop="model" label="材质"></el-table-column>
                  <el-table-column prop="specification" label="规格"></el-table-column>
                  <el-table-column prop="number" label="件数"></el-table-column>
                  <el-table-column prop="weight" label="重量（吨）"></el-table-column>
                  <el-table-column prop="availableNumber" label="可计划件数"></el-table-column>
                  <el-table-column prop="overNumber" label="实出件数"></el-table-column>
                  <el-table-column prop="planNumber" label="已计划件数"></el-table-column>
                </el-table>
              </div>
              <!-- 分页-->
              <div class="pags" style="text-align: right;">
                <el-pagination background @current-change="handleCurrentChangeXQ" :current-page="pageInfoXQ.pageNo" :page-size="pageInfoXQ.pageSize" :page-sizes="[10,20,30,40,50]" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChangeXQ" :total="totalXQ"></el-pagination>
              </div>
            </div>
          </div>
        </div>
        <!-- 作废 -->
        <el-dialog v-loading="zuoFeiLoading" title="作废" :visible.sync="zuofeiDialog" :close-on-click-modal="false" @close="zuofeiClose" center>
          <el-form label-width="90px" ref="zuofeiForm" class="demo-form-inline" :model="zuofeiForm">
            <el-form-item label="作废原因:" prop="desc" :rules="[{ required: true, message: '请输入作废原因', trigger: 'blur' }]">
              <el-input class="ipt" :validate-event="false" type="textarea" v-model="zuofeiForm.desc"></el-input>
            </el-form-item>
          </el-form>
          <div style="width:158px;margin:20px auto;">
            <el-button type="" @click="zuofeiClose">取消</el-button>
            <el-button type="primary" @click="zuofeiAddOK">确定</el-button>
          </div>
        </el-dialog>
        <el-dialog title="查看备注" :visible.sync="dialogShenheVisible" width="35%">
          <div class="demo-image__preview" v-if="!lookApproverReject" style="display: flex">
            {{shenheYijian}}
          </div>
          <span v-if="lookApproverReject">暂无备注</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogShenheVisible = false">关 闭</el-button>
            <!-- <el-button type="primary" @click="dialogVisibleImg = false"
                  >确 定</el-button> -->
          </span>
        </el-dialog>
        <!-- 新增 -->
        <xinzeng-tidan v-if="addBillVisible" :tidanFlag="tidanFlag" :addBillVisible.sync='addBillVisible' @getTime='getTime' :title="xzTitle" :xztableData="xztableData" :xiugaiObj="xiugaiObj"></xinzeng-tidan>
        <add-ChuKuPlan v-if="addPlanVisible" :addPlanVisible.sync='addPlanVisible' :planData="planData" :chePai='chePai' @getTime='getTime'></add-ChuKuPlan>
      </el-tab-pane>
      <el-tab-pane label="司机预提" name="second" :lazy="true">
        <ytd-record v-if="YTDVisible && activeName=='second'" :YTDVisible.sync="YTDVisible"></ytd-record>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import DonMessage from '@/utils/message'
import {
  getRelationCustomer, // 字典客户
  zidian,
  getTEmptyBillMasterForList, // 列表
  JfgetTEmptyBillDetailList, // 货物明细列表
  JfcancelTEmptyBillMasterJanFa, // 作废
  getSBillFileUrl, // 查看单据
  JfcompleteTEmptyBillMasterJanFa, // 完成
  getEmptyBillDetailGroup, // 货物类型下拉框
  getEmptyBillStockSummary, // 添加货物列表
  delEmptyBillDetail, // 货物明细删除（来源手动）
  getEmptyBillStockSummarySD,
  getWeighingMethodList,
  getTEmptyBillDriverList,
  getDictionaryList
} from '@/api/wms-stock.js'
import XinzengTidan from './XinzengTidan.vue'
import addChuKuPlan from './addChuKuPlan.vue'
import YtdRecord from './YTDRecord.vue'
import { exportExcel } from '@/utils/fileDown.js'
import {
  dateTimeFormat
} from '@/utils/util'
function sortArr (arr, str) {
  var _arr = []
  var _t = []
  // 临时的变量
  var _tmp

  // 按照特定的参数将数组排序将具有相同值得排在一起
  arr = arr.sort(function (a, b) {
    var s = a[str]
    var t = b[str]

    return s < t ? 1 : -1
  })

  if (arr.length) {
    _tmp = arr[0][str]
  }
  // console.log( arr );
  // 将相同类别的对象添加到统一个数组
  for (var i in arr) {
    // console.log( _tmp);
    if (arr[i][str] === _tmp) {
      // console.log(_tmp)
      _t.push(arr[i])
    } else {
      _tmp = arr[i][str]
      _arr.push(_t)
      _t = [arr[i]]
    }
  }
  // 将最后的内容推出新数组
  _arr.push(_t)
  return _arr
}
export default {
  name: 'jfChuKuTiDan',
  components: { XinzengTidan, addChuKuPlan, YtdRecord },
  data () {
    return {
      dateTimeFormat: dateTimeFormat, // 列表时间格式化
      number: '',
      searchForm: {
        pageNo: 1,
        pageSize: 20,
        billNo: '',
        steelMillName: '',
        model: '',
        specification: '',
        nowTime: '',
        dateStart: '',
        dateEnd: '',
        primaryCustomerTaxId: '',
        secondaryCustomerTaxId: '',
        plateNumber: '',
        emptyBillType: '01',
        outBillNo: ''
      },
      pageInfoXQ: {
        pageSize: 10,
        pageNo: 1
      },
      totalXQ: 0,
      dateList: '',
      totalA: 0,
      customerData: [], // 货主数据
      HQData: [], // 货权方
      FOwnerData: [],
      statusData: [
        { 'item_no': '01', 'show_name': '待处理+装车中' },
        { 'item_no': '-1', 'show_name': '全部' }
      ], // 单据状态
      h: '500px',
      tableList: [],
      nowDate: '',
      tabLoadingA: false,
      detailsData: [],
      btnFlg: [],
      btnIdArr: [
        '00cP005B001',
        '00cP005B002',
        '00cP005B003',
        '00cP005B004',
        '00cP005B005',
        '00cP005B006',
        '00cP005B007',
        '00cP005B008',
        '00cP005B009',
        '00cP005B00A',
        '00cP005B00B',
        '00cP005B00C'
      ],
      detailsH: '200px',
      zuofeiDialog: false,
      zuofeiForm: {
        desc: ''
      },
      xuanzhongArr: null,
      allNumber: '0',
      allWeight: '0',
      xuanzhongArrXQ: null,
      zuoFeiLoading: false,
      // 添加
      subTableData: [], // 添加出库计划-人车信息
      addMarkBox: false,
      addPlanVisible: false,
      addForm: {
        productType: '',
        plateNumber: '',
        driveName: '',
        driveTel: '',
        driveId: '',
        remarks: ''
      },
      planData: {},
      rules: {
        productType: [
          { required: true, message: '请选择货物类型', trigger: 'blur' }
        ],
        plateNumber: [
          { required: true, message: '请输入车牌号', trigger: 'blur' },
          this.rule.vhcNo
        ],
        driveName: [
          { required: false, message: '请输入司机姓名', trigger: 'blur' }
        ]
      },
      productTypeData: [], // 货物类型
      addTableData: [],
      submitData: [],
      addBillVisible: false,
      shenheYijian: '',
      dialogShenheVisible: false,
      lookApproverReject: false,
      addProductTypeMark: false,
      GuanlianHuowuRow: {},
      driverlist: [],
      allWeightT: 0,
      allNumberT: 0,
      tidanFlag: 0,
      xzTitle: '新增提单',
      xztableData: [],
      xiugaiObj: {},
      chePai: '',
      activeName: '',
      YTDVisible: true,
      allstockWeightBill: 0,
      allstockNumberBill: 0
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/yycCKTiDan')
    if (localStorage.getItem('activeFlag')) {
      this.activeName = localStorage.getItem('activeFlag')
    } else {
      this.activeName = 'first'
    }
    this.getTime()
    this.getRelationCustomer()
    this.getStatus()
    var _this = this
    document.onkeydown = function (e) {
      let key = window.event.keyCode
      if (key == 13) {
        _this.getTime()
      }
    }
  },
  destroyed () {
    // window.localStorage.setItem('activeFlag', '')
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let h2 = this.$refs.searchBox2.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = 0.6 * pH - h - 195 + 'px'
    this.detailsH = 0.4 * pH - h2 - 120 + 'px'
  },
  methods: {
    handleClicktab (tab, event) {
      console.log(tab.index, 'tab.index')
      if (tab.index == '1') {
        // this.chongzhiT()
        window.localStorage.setItem('activeFlag', 'second')
      } else {
        this.chongzhi()
        window.localStorage.setItem('activeFlag', 'first')
      }
    },
    driverSelect (val) {
      console.log(val)
      this.driverlist.forEach(item => {
        if (item.plateNumber == val) {
          this.addForm.driveName = item.driverName
          this.addForm.driveTel = item.telephone
          this.addForm.driveId = item.idNumber
        }
      })
    },
    delXQ () {
      if (this.xuanzhongArrXQ == null) {
        this.$message({ message: '请选择一条数据', type: 'error' })
        return
      } else if (this.xuanzhongArr.emptyBillType != '0') {
        this.$message({ message: '待处理的提货单可以删除；其他状态的提货单不能删除', type: 'error' })
        return
      } else if (this.xuanzhongArr.source != '0') {
        this.$message({ message: '数据来源必须是手动', type: 'error' })
        return
      }
      this.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delEmptyBillDetail(
          { billId: this.xuanzhongArr.billId, billDetailId: this.xuanzhongArrXQ.billDetailId }
        )
          .then(res => {
            console.log(res)
            this.$message({ message: '删除成功', type: 'success' })
            this.getSeatchData()
          })
          .catch(err => {
            this.$message({ message: err.message, type: 'error' })
          })
      }).catch(() => {

      })
    },
    xinzeng () {
      this.addBillVisible = true
      this.xzTitle = '新增提单'
    },
    xiugai () {
      if (this.tableList.length == 0) {
        DonMessage.error('暂无数据')
        return
      }
      if (this.xuanzhongArr == null) {
        DonMessage.error('请先选择一条数据')
        return
      }
      if (this.xuanzhongArr.emptyBillType == '1') {
        this.tidanFlag = 1
      } else {
        this.tidanFlag = 0
      }
      if (this.xuanzhongArr.emptyBillType == '0' || this.xuanzhongArr.emptyBillType == '1') {
        this.addBillVisible = true
        this.xzTitle = '修改提单'
        this.xiugaiObj = this.xuanzhongArr
        this.xztableData = this.detailsData
      } else {
        DonMessage.error('该条数据不能修改')
      }
    },
    // 获取当前时间
    getTime () {
      this.nowDate = (new Date()).getTime()
      this.searchForm.nowTime = this.timeStamp(this.nowDate)
      if (this.dateList) {
        this.searchForm.dateStart = this.dateList[0] + ' 00:00:00'
        this.searchForm.dateEnd = this.dateList[1] + ' 23:59:59'
        // console.log(this.searchForm.dateStart, this.searchForm.dateEnd)
      }
      this.getSeatchData(this.searchForm)
    },
    // 时间格式化
    dateFormat (date) {
      let format = 'yyyy-MM-dd hh:mm:ss'
      if (date != 'Invalid Date') {
        var o = {
          'M+': date.getMonth() + 1, // month
          'd+': date.getDate(), // day
          'h+': date.getHours(), // hour
          'm+': date.getMinutes(), // minute
          's+': date.getSeconds(), // second
          'q+': Math.floor((date.getMonth() + 3) / 3), // quarter
          'S': date.getMilliseconds() // millisecond
        }
        if (/(y+)/.test(format)) {
          format = format.replace(RegExp.$1,
            (date.getFullYear() + '').substr(4 - RegExp.$1.length))
        }
        for (var k in o) {
          if (new RegExp('(' + k + ')').test(format)) {
            format = format.replace(RegExp.$1,
              RegExp.$1.length == 1 ? o[k]
                : ('00' + o[k]).substr(('' + o[k]).length))
          }
        }
        return format
      }
      return ''
    },
    timeStamp: function (value) {
      let date = new Date()
      let Y = date.getFullYear()
      let M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)
      let D = date.getDate() < 10 ? ('0' + date.getDate()) : date.getDate()
      let hours = date.getHours()
      let minutes = date.getMinutes() < 10 ? ('0' + date.getMinutes()) : date.getMinutes()
      let seconds = date.getSeconds() < 10 ? ('0' + date.getSeconds()) : date.getSeconds()
      date = Y + '-' + M + '-' + D + ' ' + hours + ':' + minutes + ':' + seconds
      return date
    },
    // 获取一级、二级客户
    getRelationCustomer () {
      getRelationCustomer().then(res => {
        this.customerData = res // 客户
        this.HQData = JSON.parse(JSON.stringify(res))
        this.HQData.unshift({ 'custerName': '无货权方', 'taxpayerNumber': '-1' })
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 货物类型
    getEmptyBillDetailGroup () {
      getEmptyBillDetailGroup({
        billId: this.xuanzhongArr.billId
      }).then(res => {
        this.productTypeData = res
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    getStatus () {
      zidian({
        groupNo: 'empty_bill_type'
      }).then(res => {
        Array.prototype.push.apply(this.statusData, res)// 将res数组的所有元素加入到statusData的数组后面
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 查询接口
    getSeatchData () {
      this.tabLoadingA = true
      getTEmptyBillMasterForList(this.searchForm)
        .then((res) => {
          this.tabLoadingA = false
          this.allWeightT = res.all.allWeight
          this.allNumberT = res.all.allNumber
          this.allstockWeightBill = res.allstockWeightBill
          this.allstockNumberBill = res.allstockNumberBill
          // res.pageInfo.list.forEach((item) => {
          //   if (this.nowDate > item.failureTime) {
          //     item.invalidFlag = '失效'
          //   } else {
          //     item.invalidFlag = '正常'
          //   }
          // })
          this.tableList = res.pageInfo.list
          if (res.pageInfo.list.length > 0) {
            this.xuanzhongArr = res.pageInfo.list[0]
            this.$nextTick(() => {
              this.$refs.tableList.setCurrentRow(res.pageInfo.list[0])
            })
            this.JfgetTEmptyBillDetailList()
          } else {
            this.tableList = []
            this.totalA = 0
            this.allWeight = '0'
            this.allNumber = '0'
            this.detailsData = []
            this.totalXQ = 0
          }
          this.totalA = res.pageInfo.total
        })
        .catch((err) => {
          this.tabLoadingA = false
          // console.log(err.message)
          this.$message.error(err.message)
        })
    },
    // 货物详情
    JfgetTEmptyBillDetailList () {
      JfgetTEmptyBillDetailList({
        billId: this.xuanzhongArr.billId,
        ...this.pageInfoXQ
      })
        .then(res => {
          // console.log(res)
          this.allWeight = res.all.allWeight
          this.allNumber = res.all.allNumber
          this.detailsData = res.pageInfo.list
          this.totalXQ = res.pageInfo.total
          this.xuanzhongArrXQ = res.pageInfo.list[0]
          // this.getThreadSummaryTotalWNs()
          // this.$nextTick(() => {
          //   this.$refs.tabref.setCurrentRow(res.list[0])
          // })
        })
        .catch(error => {
          console.log(error)
          DonMessage.error(error.message)
        })
    },
    searchClick () {
      this.getTime()
    },

    chongzhi () {
      this.searchForm.pageNo = 1
      this.searchForm.pageSize = 20
      this.searchForm.nowTime = ''
      this.searchForm.dateStart = ''
      this.searchForm.dateEnd = ''
      this.searchForm.billNo = ''
      this.searchForm.primaryCustomerTaxId = ''
      this.searchForm.secondaryCustomerTaxId = ''
      this.searchForm.plateNumber = ''
      this.searchForm.emptyBillType = '01'
      this.searchForm.invalidFlag = ''
      this.searchForm.ownerCustomerTaxId = ''
      this.searchForm.outBillNo = ''
      this.searchForm.model = ''
      this.searchForm.specification = ''
      this.searchForm.steelMillName = ''
      this.dateList = ''
      this.getTime()
    },
    addPlan () {
      if (this.xuanzhongArr == null) {
        this.$message({ message: '请先选择一条数据', type: 'error' })
      } else {
        if (this.xuanzhongArr.emptyBillType == '0' || this.xuanzhongArr.emptyBillType == '1') {
          this.addPlanVisible = true
          this.planData = this.xuanzhongArr
          this.chePai = this.searchForm.plateNumber
        } else {
          DonMessage.error('该条数据不能添加出库计划')
        }
      }
    },
    // 完成
    finished () {
      if (this.tableList.length == 0) {
        this.$message({ message: '暂无数据', type: 'error' })
        return
      }
      if (this.xuanzhongArr == null) {
        this.$message({ message: '请先选择一条数据', type: 'error' })
        return false
      }
      if (this.xuanzhongArr.emptyBillType != '1') {
        this.$message({ message: '该状态不可操作', type: 'error' })
        return false
      }
      this.$confirm('是否确定此操作？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        JfcompleteTEmptyBillMasterJanFa({
          billId: this.xuanzhongArr.billId // 出库提单id
        }).then(res => {
          DonMessage.success('完成成功')
          this.getTime()
        }).catch(err => {
          DonMessage.error(err.message)
        })
      }).catch(() => {
      })
    },
    // 作废
    cancellation () {
      if (this.xuanzhongArr) {
        if (this.xuanzhongArr.emptyBillType == '2') {
          DonMessage.error('该条数据的状态不能作废')
        } else if (this.xuanzhongArr.emptyBillType == '1') {
          DonMessage.error('正在装车，不能作废')
        } else {
          this.zuofeiDialog = true
        }
      } else {
        DonMessage.error('请选择一条数据进行操作')
      }
    },
    // 点击
    dianjixuanzhong (row) {
      console.log(row)
      this.xuanzhongArr = {}
      this.xuanzhongArr = row
      this.allWeight = '0'
      this.allNumber = '0'
      this.detailsData = []
      this.totalXQ = 0
      this.JfgetTEmptyBillDetailList()
    },
    // selectGoods () {},
    dianjiXiangqingtable (row) {
      this.xuanzhongArrXQ = {}
      this.xuanzhongArrXQ = row
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchForm.pageSize = val
      this.getTime()
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchForm.pageNo = val
      this.getTime()
    },
    // 查看图片
    handleClick (row, type) {
      if (type == 'zp') {
        let formData = new FormData()
        formData.append('url', row.path)
        getSBillFileUrl(formData).then(res => {
          this.$router.push({
            // 核心语句
            path: '/pdf', // 跳转的路径
            query: {
              // 路由传参时push和query搭配使用 ，作用时传递参数
              path: res
            }
          })
        })
      } else {
        this.dialogShenheVisible = true
        this.shenheYijian = row.remark
      }
    },
    handleCurrentChangeXQ (val) {
      this.pageInfoXQ.pageNo = val
      this.JfgetTEmptyBillDetailList()
    },
    handleSizeChangeXQ (val) {
      this.pageInfoXQ.pageSize = val
      this.JfgetTEmptyBillDetailList()
    },
    // dialog
    zuofeiClose () {
      this.zuofeiDialog = false
      this.$refs.zuofeiForm.resetFields()
      this.zuofeiForm.desc = ''
    },
    // 作废确定
    zuofeiAddOK () {
      this.$refs.zuofeiForm.validate((valid) => {
        if (valid) {
          this.zuoFeiLoading = true
          JfcancelTEmptyBillMasterJanFa({
            billId: this.xuanzhongArr.billId, // （出库提单id  必填）
            voidReason: this.zuofeiForm.desc// （作废原因 必填）
          }).then(res => {
            this.zuoFeiLoading = false
            DonMessage.success('作废成功')
            this.zuofeiDialog = false
            this.getTime()
          }).catch(err => {
            this.zuoFeiLoading = false
            DonMessage.error(err.message)
          })
        } else {
          return false
        }
      })
    },
    // 添加关闭
    addClose (formName) {
      this.addMarkBox = false
      this.$refs[formName].resetFields()
      this.addTableData = []
    },
    // 添加取消
    addCancel (formName) {
      this.addMarkBox = false
      this.$refs[formName].resetFields()
      this.addTableData = []
      console.log(this.addTableData, 'this.addTableData')
    },
    // 点击添加货物
    addGoodsName () {
      // if (this.addForm.productType == '') {
      //   DonMessage.error('请选择货物类型')
      // } else {
      if (this.xuanzhongArr.source == '0') {
        getEmptyBillStockSummarySD({ billId: this.xuanzhongArr.billId })
          .then(res => {
            console.log(res)
            res.forEach(item => {
              item.number = ''
              item.weight = ''
              item.allWeight = ''
              item.productTypeName = item.productName
              item.disWeight = false
            })
            this.addTableData = res
            this.addTableData.forEach(item => {
              getWeighingMethodList(
                {
                  productType: item.productType
                }
              )
                .then(res => {
                  console.log(res)
                  if (res.length > 0 && res[0].outWeighingMethod == 2) {
                    item.disWeight = false
                  } else {
                    item.disWeight = true
                  }
                })
                .catch(err => {
                  DonMessage.error(err.message)
                })
            })
          })
          .catch(err => {
            this.$message({ message: err.message, type: 'error' })
          })
      } else {
        getEmptyBillStockSummary({
          billId: this.xuanzhongArr.billId // （出库提单id 必填）
          // productType: this.addForm.productType// （货物类型id 必填
        }).then(res => {
          res.forEach(item => {
            item.number = ''
            item.disWeight = false
            item.weight = ''
            item.allWeight = ''

            item.productTypeName = item.productName
          })
          this.addTableData = res
          this.addTableData.forEach(item => {
            getWeighingMethodList(
              {
                productType: item.productType
              }
            )
              .then(res => {
                console.log(res)
                if (res.length > 0 && res[0].outWeighingMethod == 2) {
                  item.disWeight = false
                } else {
                  item.disWeight = true
                }
              })
              .catch(err => {
                DonMessage.error(err.message)
              })
          })
          console.log(this.addTableData, 'this.addTableData')
        }).catch(err => {
          DonMessage.error(err.message)
        })
      }

      // }
    },
    NumberInput (val) {
      if (val.stockAvailableNumber && val.number > val.stockAvailableNumber) {
        this.$message({ message: '出库件数不能大于库存可提件数', type: 'error' })
        val.number = ''
        val.weight = ''
        val.allWeight = ''
        return
      }
      // console.log(val)
      val.weight = (val.number / 1 * val.singletonWeight / 1).toFixed(4)
      val.allWeight = (val.number / 1 * val.singletonWeight / 1).toFixed(4)
    },
    NumberInputWeight (val) {
      console.log(val)
      // val.weight = Number(val.weight).toFixed(4)
      // val.weight = (val.number / 1 * val.singletonWeight / 1).toFixed(4)

      val.allWeight = Number(val.allWeight).toFixed(4)
    },
    // 删除
    deleteAdd (scope) {
      this.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.addTableData.splice(scope.$index, 1)
      })
    },
    tianjiahuowu (row) {
      this.xuanzhongArr = row
      if (this.xuanzhongArr.source != 0) {
        this.$message({ message: '数据来源必须是手动', type: 'error' })
        return
      } else if (this.xuanzhongArr.emptyBillType != '0') {
        this.$message({ message: '待处理的提货单可以添加货物；其他状态的提货单不能添加货物', type: 'error' })
        return
      }
      this.addProductTypeMark = true

      this.GuanlianHuowuRow = row
    },
    getTEmptyBillDriverLists () {
      getTEmptyBillDriverList({ billId: this.xuanzhongArr.billId })
        .then(res => {
          console.log(res)
          this.driverlist = res
        })
        .catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
    },
    getDictionaryLists () {
      getDictionaryList({ tenantCode: window.localStorage.getItem('tenantCode'), groupNo: 'out_empty_remark' })
        .then(res => {
          console.log(res)
          this.addForm.remarks = res[0].remark
        })
        .catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
    },
    // 导出
    daochu () {
      exportExcel(
        this.global.wmsStockName + '/tEmptyForJanFa/exportEmptyBillMasterJanFa',
        { ...this.searchForm },
        '出库提单表'
      )
    }
  }

}
</script>

<style lang="less" scoped>
.ChukuBill {
  padding-left: 5px;
}
.detailsTitle-sum {
  padding-left: 5px;
  .num {
    color: rgb(224, 0, 32);
  }
}
.el-tabs__header{
  margin-bottom: 0;
}
</style>
